import styled from 'styled-components'

export const StyledSegmentAnalytic = styled.div`
  [data-html2canvas-ignore] {
    display: none;
  }
`
